const translations = {
    ru: {
        link: "Ссылка",
        linkNotSet: "Ссылка не установлена. Этот канал связи временно недоступен. Пожалуйста, воспользуйтесь другим каналом.",
        scanQrCode: "Чтобы написать в {name}, отсканируйте QR-код или перейдите по ссылке ниже.",
        openChannel: "Открыть {name}"
    },
    en: {
        link: "Link",
        linkNotSet: "Link not installed. This communication channel is temporarily unavailable. Please use another channel.",
        scanQrCode: "To write to {name}, scan the QR code or follow the link below.",
        openChannel: "Open {name}"
    },
    de: {
        link: "Link",
        linkNotSet: "Link nicht installiert. Dieser Kommunikationskanal ist vorübergehend nicht verfügbar. Bitte verwenden Sie einen anderen Kanal.",
        scanQrCode: "Um an {name} zu schreiben, scannen Sie den QR-Code oder folgen Sie dem Link unten.",
        openChannel: "{name} öffnen"
    },
    uk: {
        link: "Посилання",
        linkNotSet: "Посилання не встановлено. Цей канал зв'язку тимчасово недоступний. Будь ласка, скористайтесь іншим каналом.",
        scanQrCode: "Щоб написати {name}, відскануйте QR-код або перейдіть за посиланням нижче.",
        openChannel: "Відкрити {name}"
    },
}

export function trans(lang, key, replacement) {
    let result
    if (translations[lang] && translations[lang][key]) {
        result = translations[lang][key]
    } else {
        result = translations.en[key] ? translations.en[key] : key
    }

    if (replacement) {
        for (let key in replacement) {
            result = result.replace(`{${key}}`, replacement[key])
        }
    }

    return result
}
